import { render, staticRenderFns } from "./bimTextSmall.vue?vue&type=template&id=438fb726&scoped=true&lang=html&"
import script from "./bimTextSmall.vue?vue&type=script&lang=js&"
export * from "./bimTextSmall.vue?vue&type=script&lang=js&"
import style0 from "./bimTextSmall.vue?vue&type=style&index=0&id=438fb726&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438fb726",
  null
  
)

export default component.exports